'use client';

import { c as _c } from "react/compiler-runtime";
import type { FeatureValue, ServiceMetric } from '@/modules/service-purchase/types';
import { FeatureRow } from './feature-row';
export interface ServiceCatalogRowProps {
  label: string;
  sublabel?: string;
  values: Record<string, FeatureValue>;
  metrics?: ServiceMetric[];
}
function ServiceCatalogRow(t0) {
  const $ = _c(5);
  const {
    label,
    sublabel,
    values,
    metrics
  } = t0;
  let t1;
  if ($[0] !== label || $[1] !== metrics || $[2] !== sublabel || $[3] !== values) {
    t1 = <FeatureRow label={label} sublabel={sublabel} values={values} metrics={metrics} />;
    $[0] = label;
    $[1] = metrics;
    $[2] = sublabel;
    $[3] = values;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export { ServiceCatalogRow };